<template>
  <div></div>
</template>

<script>
import domain from '@/config/systemDomain'
import moblieDomain from '@/config/moblieDomain'

export default {
  created() {
    // redirectUrl：待重定向的地址
    // code：微信的回调code
    let [code, redirectUrl] = decodeURIComponent(window.location.href).split('#/wxRedirect?href=')     
    code = code.split('?')[1]
    let addCode = false
    if (redirectUrl.indexOf('#') > -1) {
      addCode = this.hasHashQUery(redirectUrl)
    } else {
      addCode = this.hasQuery(redirectUrl)
    }
    // 根据redirectUrl中的query有无，将code值添加到url的后面
    redirectUrl = redirectUrl + (addCode ? `&${code}` : `?${code}`)

    if (redirectUrl.indexOf(domain.ph_domain) > -1 ||  // 配货
        redirectUrl.indexOf(domain.old_retail_domain) > -1 ||  // 老零售
        redirectUrl.indexOf(moblieDomain.cg) > -1 ||  // 手机端采购助手
        redirectUrl.indexOf(domain.wsc_domain + '/mall') > -1 ||  // 微商城
        redirectUrl.indexOf(domain.pf_domain + '/mmanage') > -1 || // 批发
        redirectUrl.indexOf(domain.pf_domain + '/easy') > -1 || // 批发易
        redirectUrl.indexOf(domain.pf_domain + '/wxcustomer') > -1 // 批发采购数据详情
    ) {
      window.location.href = redirectUrl
    } else if (redirectUrl.indexOf(domain.center_domain) > -1 ||  // 商户中心
              redirectUrl.indexOf(moblieDomain.pps) > -1 ||  // 品牌商
              redirectUrl.indexOf("bbs") !== -1 // 社区
    ) {
      this.$fetch.post({
        url: '/login?method=login_by_wx_code',
        params: {
          code: (code.split('=')[1]).split('&')[0]
        },
        withCredentials: true
      }).then(() => {
        redirectUrl += '&login=logined'  // 设置是否登录过了的
        // 跳转到各个子系统
        window.location.href = decodeURIComponent(redirectUrl)
      }).catch(e => {
        this.$message.error(e.error_text || '网络错误');
      })
    } else if (redirectUrl.indexOf(moblieDomain.new_ls) > -1 ) {   //  redirectUrl.indexOf(moblieDomain.new_ls) > -1 ||  // 新零售
      this.$fetch.post({
        url: '/login?method=login_by_wx_code',
        params: {
          code: (code.split('=')[1]).split('&')[0],
          oa: 'oa_lingshou'
        },
        withCredentials: true
      }).then(() => {
        redirectUrl += '&login=logined'  // 设置是否登录过了的
        // 跳转到各个子系统
        window.location.href = decodeURIComponent(redirectUrl)
      }).catch(e => {
        this.$message.error(e.error_text || '网络错误');
      })
    }
  },

  methods: {
    hasHashQUery(redirectUrl) {
      return redirectUrl.split('#')[1].indexOf('?') > -1
    },

    hasQuery(redirectUrl) {
      return redirectUrl.indexOf('?') > -1
    }
  }
}
</script>

<style lang="scss" scoped>
</style>